// @flow
import { Drawer } from '@mui/material'
import Box from '@mui/material/Box'

type Props = {
	show: boolean,
	autoClose?: boolean, //automatically close on background click or escape button
	children?: React.ReactNode,
	onBackgroundClick?: Function
}

const QuickView = (props: Props) => {
	const { show, autoClose = false, children, onBackgroundClick, sx = {} } = props
	const onClose = (evt, details) => {
		if (!autoClose && (details === "backdropClick" || details === "escapeKeyDown")) return
		onBackgroundClick(evt, details)
	}
	return (
		<Drawer
			anchor={'right'}
			open={show}
			onClose={onClose}
		>
			<Box
				sx={{
					minWidth: '340px',
					...sx
				}}
				p={1.5}
			>
				{children}
			</Box>
		</Drawer>
	)
}

export default QuickView
